// extracted by mini-css-extract-plugin
export default {"title":"ClinicPage_title__W60dx","row-breadcrumb":"ClinicPage_row-breadcrumb__9jYY4","buttons":"ClinicPage_buttons__5VZ-Q","remove-button":"ClinicPage_remove-button__qcR4j"};